import { render, staticRenderFns } from "./old-data.vue?vue&type=template&id=c4589694&scoped=true&"
import script from "./old-data.vue?vue&type=script&lang=js&"
export * from "./old-data.vue?vue&type=script&lang=js&"
import style0 from "./old-data.vue?vue&type=style&index=0&id=c4589694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4589694",
  null
  
)

export default component.exports